var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { Component } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { omit } from "lodash";
import { Col, FormControl } from "react-bootstrap";
import id from "@irati/utils/id";
import { ValidationInput } from "@irati/utils/validation";
import { injectIntl, getResolvedMessage } from "@irati/utils/lang";
import { FormGroup } from "../Form";
import ErrorText from "../ErrorText";
import HintText from "../HintText";
import CharacterCountDown from "./CharacterCountDown";
import RichEditorWrapper from "./RichEditorWrapper";
import Label from "./styled/Label";
var FormItemTextArea = /** @class */ (function (_super) {
    __extends(FormItemTextArea, _super);
    function FormItemTextArea(props) {
        var _this = _super.call(this, props) || this;
        _this.handleBlur = function (e) {
            _this.setState({ blurred: true });
            _this.validation.update();
            _this.props.onBlur(e, _this.state.value);
        };
        _this.handleChange = function (e) {
            var value = e.target.value;
            if (value === "") {
                value = null;
            }
            _this.setState({ value: value });
            _this.props.onChange(value);
        };
        _this.state = {
            renderRichEditor: false,
            value: props.value,
            blurred: false
        };
        _this.inputRef = undefined;
        _this.validation = new ValidationInput(_this);
        return _this;
    }
    FormItemTextArea.prototype.componentDidMount = function () {
        if (this.inputRef) {
            this.setState({ renderRichEditor: true });
        }
    };
    FormItemTextArea.prototype.componentDidUpdate = function (prevProps, prevState) {
        if (this.state.blurred) {
            this.validation.update(prevProps, prevState);
        }
    };
    FormItemTextArea.prototype.componentWillUnmount = function () {
        this.validation.destroy();
    };
    FormItemTextArea.prototype.UNSAFE_componentWillReceiveProps = function (nextProps) {
        this.setState({ value: nextProps.value });
    };
    FormItemTextArea.prototype.render = function () {
        var _this = this;
        var _a = this.props, hideLabel = _a.hideLabel, hint = _a.hint, maxLength = _a.maxLength, name = _a.name, textReplaceTypes = _a.textReplaceTypes, type = _a.type;
        var _b = this.state, errorMsg = _b.errorMsg, renderRichEditor = _b.renderRichEditor;
        var value = this.state.value;
        var idNamespace = id("textarea", this.props);
        var inputId = id("input", idNamespace) || name;
        var className = classNames("perkboxInput", this.props.className);
        if (!value) {
            // if null/undefined => use ""
            value = "";
        }
        var inputProps = omit(this.props, [
            "className",
            "formatMessage",
            "hideLabel",
            "hint",
            "id",
            "label",
            "onBlur",
            "onChange",
            "textReplaceTypes",
            "translate",
            "validation",
            "value"
        ]);
        return (React.createElement(FormGroup, { id: idNamespace, className: className, controlId: inputId, validationState: errorMsg ? "error" : undefined },
            React.createElement(Col, { hidden: hideLabel, xs: 12 },
                React.createElement(Label, { id: id("label", idNamespace), error: errorMsg, htmlFor: inputId }, getResolvedMessage(this, "label"))),
            React.createElement(Col, { xs: 12 },
                React.createElement(FormControl, __assign({}, inputProps, { inputRef: function (ref) {
                        _this.inputRef = ref;
                        if (inputProps.inputRef) {
                            inputProps.inputRef(ref);
                        }
                    }, componentClass: "textarea", onBlur: this.handleBlur, onChange: this.handleChange, placeholder: getResolvedMessage(this, "placeholder"), style: hint ? { marginBottom: 0 } : undefined, type: type, value: value })),
                renderRichEditor && textReplaceTypes.length > 0 && (React.createElement(RichEditorWrapper, { hasError: !!errorMsg, inputRef: this.inputRef, onChange: this.handleChange, textReplaceTypes: textReplaceTypes, value: value })),
                errorMsg && (React.createElement("div", null,
                    React.createElement(ErrorText, { id: id("error-copy", idNamespace), small: true }, getResolvedMessage(this, "errorMsg", this.state)))),
                hint && (React.createElement("div", null,
                    React.createElement(HintText, { id: id("hint-copy", idNamespace), small: true }, hint))),
                maxLength && (React.createElement("div", null,
                    React.createElement(CharacterCountDown, { maxLength: maxLength, value: value }))))));
    };
    FormItemTextArea.contextTypes = {
        currentScreen: PropTypes.string
    };
    FormItemTextArea.defaultProps = {
        className: "",
        hideLabel: false,
        onBlur: function () { return undefined; },
        textReplaceTypes: [],
        type: "textarea"
    };
    return FormItemTextArea;
}(Component));
export { FormItemTextArea };
export default injectIntl(FormItemTextArea);
